import React from 'react'
import prefetchDetectedMarket from 'graphql/prefetchers/prefetchDetectedMarket'
import { NextPage } from 'next'

import PressCoverage from 'components/PressCoverage/PressCoverage'
import PublicLayout from 'components/PublicLayout/PublicLayout'

const PressPage: NextPage = (): JSX.Element => (
  <PublicLayout hidePress headerBackground="#f8284e">
    <main style={{ maxWidth: 800, width: '96%', margin: '50px auto 200px' }}>
      <PressCoverage noTitle={false} />
    </main>
  </PublicLayout>
)

PressPage.getInitialProps = prefetchDetectedMarket

export default PressPage
